module.exports = __webpack_public_path__ + "blissweb-rg.2abf532f4992ddbe469b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Rg/blissweb-rg.woff
// module id = 481
// module chunks = 5